import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { LisLabels } from "../../screens/_label/lis_labels/lis_labels.js";  
import * as menu from "../../assets/menus/menu.js";
const LisTableHeader = ({
  filtersConfig = [],
  values = {},
  onChange,
  onSearch,
  onReset,
  isLoading = false,
  uniformControlStyle,
  columnClass = "col-auto",
  showButtons = true,
  enterTriggersSearch = true,
}) => {
  const defaultControlStyle = uniformControlStyle || {
    height: 42,
    minHeight: 42,
  };
  const { t } = useTranslation();

  const i18n = menu.getI18n();
  i18n.addResourceBundle("it", "lisLabels", LisLabels.it, true, true);
  i18n.addResourceBundle("en", "lisLabels", LisLabels.en, true, true);


  const hasAnyFilterValue = React.useMemo(() => {
    return filtersConfig.some((cfg) => {
      const v = values?.[cfg.key];
      if (typeof v === "string") return v.trim() !== "";
      if (Array.isArray(v)) return v.length > 0;
      return v !== undefined && v !== null && v !== "";
    });
  }, [filtersConfig, values]);

  const handleInputChange = (key) => (e) => {
    if (onChange) {
      onChange(key, e.target.value);
    }
  };

  const handleKeyPress = (e) => {
    if (
      enterTriggersSearch &&
      e.key === "Enter" &&
      onSearch &&
      hasAnyFilterValue
    ) {
      onSearch();
    }
  };
  const controlWidthPx =
    typeof uniformControlStyle?.width === "number"
      ? uniformControlStyle.width
      : null;
  const buttonBaseStyle = {
    height: defaultControlStyle.height,
    minHeight: defaultControlStyle.minHeight,
  };

  const renderControl = (cfg) => {
    const { key, type = "text", placeholder, options = [] } = cfg;
    const value = values?.[key] ?? "";
    const commonProps = {
      className: "form-control form-control-sm",
      style: defaultControlStyle,
      value,
      onChange: handleInputChange(key),
    };
    if (type === "date") {
      return <input type="date" {...commonProps} />;
    }
    if (type === "select") {
      const isMulti = !!cfg.isMulti;
      const mappedOptions = options.map((opt) =>
        typeof opt === "object" ? opt : { value: opt, label: String(opt) }
      );
      const currentValue = values?.[key];
      const selectedValue = isMulti
        ? Array.isArray(currentValue)
          ? mappedOptions.filter((o) => currentValue.includes(o.value))
          : []
        : mappedOptions.find((o) => o.value === currentValue) || null;
      const selectStyles = {
        control: (base) => ({
          ...base,
          minHeight: defaultControlStyle.minHeight,
          height: defaultControlStyle.height,
          width: controlWidthPx,
          minWidth: controlWidthPx,
          borderRadius: "0.5rem",
        }),
        valueContainer: (base) => ({
          ...base,
          padding: "0 8px",
        }),
        indicatorsContainer: (base) => ({
          ...base,
          height: defaultControlStyle.height,
        }),
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      };
      return (
        <Select
          options={mappedOptions}
          value={selectedValue}
          placeholder={placeholder || ""}
          onChange={(opt) =>
            onChange &&
            onChange(
              key,
              isMulti ? (opt || []).map((o) => o.value) : opt?.value ?? ""
            )
          }
          isMulti={isMulti}
          isClearable
          
          
          styles={selectStyles}
          classNamePrefix="rs"
          onKeyDown={handleKeyPress}
          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        />
      );
    }
    return (
      <input
        type="text"
        placeholder={placeholder || ""}
        onKeyPress={handleKeyPress}
        {...commonProps}
      />
    );
  };

  return (
    <div className="card ">
  <div className="card-body px-3 pt-2 pb-4">
    {/* 1. Use d-flex instead of row to stop the "bleeding" over borders.
           align-items-end keeps buttons level with the input boxes. */}
    <div className="d-flex align-items-end gap-3">
      
      {/* 2. Filter container: flex-grow-1 ensures it takes all available space.
           We use an inner row here so filters can still use your columnClass. */}
      <div className="flex-grow-1">
        <div className="row g-2 m-0"> {/* m-0 here is critical to stop internal overflow */}
          {filtersConfig.map((cfg, idx) => (
            <div className={columnClass} key={cfg.key || idx}>
              {cfg.label && (
                <label className="form-label small mb-1 text-nowrap">{cfg.label}</label>
              )}
              {renderControl(cfg)}
            </div>
          ))}
        </div>
      </div>

      {/* 3. Button container: flex-shrink-0 ensures buttons NEVER wrap or get squished. */}
      <div className="flex-shrink-0">
        <div className="d-flex gap-2">
          <button
            className="btn btn-primary btn-sm text-nowrap"
            onClick={onSearch}
            disabled={isLoading || !hasAnyFilterValue}
            style={{ ...buttonBaseStyle, minWidth: '130px' }}
          >
          { t("searchButton", { ns: "lisLabels" })}
          </button>

          <button
            className="btn btn-outline-secondary btn-sm text-nowrap"
            onClick={onReset}
            disabled={isLoading}
            title="Reset"
            style={{ ...buttonBaseStyle, minWidth: '80px' }}
          >
            { t("resetButton", { ns: "lisLabels" })}
          </button>
        </div>
      </div>
      
    </div>
  </div>
</div>
  );
};

export default LisTableHeader;
